export default [
  {
    content: "배관 구성풍(파이프, 플랜지, 밸브 등)은 국내·외 산업표준에 적합한 규격품으로 설치하였는가?",
    isChecked: "",
  },
  {
    content: "배관 용접부, 노즐 및 밸브 등에 누출이 없고 누설 흔적도 없는가?",
    isChecked: "",
  },
  {
    content: "육안검사 시 배관에 균열 또는 이상이 없는가?",
    isChecked: "",
  },
  {
    content: "배관 외면의 보온재가 파손되거나 탈락되지 않고 보온설비(Steam/electric tracing)가 적정하게 유지 관리되고 있는가?",
    isChecked: "",
  },
  {
    content: "배관에서 누설된 응축수, 열매유 등이 보온재에 스며들어 체류하지 않는가?",
    isChecked: "",
  },
  {
    content: "배관 연결부 플랜지에 체결된 볼트 및 너트는 풀림이나 나사의 파손이 없고 여유 나사산을 고려하여 견고하게 체결되었는가?",
    isChecked: "",
  },
  {
    content: "배관 지지대에 외력에 의한 손상 및 변형이 없는가?",
    isChecked: "",
  },
  {
    content: "폭발 위험장소 내에 배관이 위치한 경우, 지지대가 내화구조로 설치되어 있으며 시공상태도 양호한가?",
    isChecked: "",
  },
  {
    content: "배관 연결부의 개스킷(Gasket)은 취급 유체의 온도·압력에 적합하고 내부식성이 있는 재질인가?",
    isChecked: "",
  },
  {
    content: "고온·고압 배관을 지지하고 있는 스프링 행거 및 서포트(Spring hanger & Support)의 설정치(Cold, Hot)는 적절하게 유지되는가?",
    isChecked: "",
  },
  {
    content: "배관이 적절한 구배(Slope)로 시공되어, 배관 내부에 Air Pocket이나 Dead Leg(액이 고여서 체류할 수 있는 구간) 생성은 없는가?",
    isChecked: "",
  },
  {
    content: "가동 중 배관계의 비정상적 진동 및 소음이 감지되지 않는가?",
    isChecked: "",
  },
  {
    content: "벨로우즈, 호스 및 플렉시블 배관이 아예 없거나 꼭 필요한 곳에만 설치되어 있는가?",
    isChecked: "",
  },
  {
    content: "배관에 설치된 밸브 핸들 또는 손잡이에 개폐 방항을 표시하거나 개폐 시 모두 같은 방항으로 조작하도록 설치되어 있는가?",
    isChecked: "",
  },
  {
    content: "혼합 위험이 있는 물질을 직접 접촉하지 않도록 배관을 별도 계통으로 설치하고, 별도 설치가 어려운 경우 차단밸브나 체크밸브를 설치하여 역류 및 혼합을 방지하였는가?",
    isChecked: "",
  },
  {
    content: "공기 제거 밸브(Air vent valve)가 설치되어 있고 드레인밸브 말단에 캡 또는 맹판으로 막음 처리를 하였는가?",
    isChecked: "",
  },
  {
    content: "정비 보수 작업 전 배관의 유체 차단을 위한 LOTO(Lock Out, Tag Out) 절차를 반드시 준수하는가?",
    isChecked: "",
  },
  {
    content: "필요시 배관 내 유체 흐름을 표시하여 관리하는가?",
    isChecked: "",
  },
];
